export const expandedViewStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.3)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1100
  },
  backdrop: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.3)",
    backdropFilter: "blur(2px)",
    zIndex: -1,
  },
  header: {
    position: "relative",
    padding: "16px 24px",
    borderBottom: "1px solid #e5e7eb",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f9fafb",
  },
  panel: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    maxWidth: "80vw",
    height: "85vh",
    width: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
    animation: "slideIn 0.3s ease-out",
    color: "#111827",
    fontFamily: "'Inter', sans-serif",
    zIndex: 1,
  },
  title: {
    margin: 0,
    position: "relative",
    fontSize: "20px",
    fontWeight: 600,
    color: "#1f2937",
    maxWidth: "550px",
    overflowX: "auto"
  },
  key: {
    width: "25%",
    fontWeight: 600,
    color: "#374151",
    fontSize: "1.1rem",
    wordWrap: "break-word",
    paddingRight: "10px"
  },
  value: {
    // width: "75%",
    width: "95%",
    fontSize: "0.975rem",
    color: "#1f2937",
    wordWrap: "break-word",
    paddingLeft: "10px",
    maxHeight: 210,
    overflowY: "auto",
    whiteSpace: 'pre-wrap',
  },
  subsheetValue: {
    // width: "75%",
    width: "95%",
    fontSize: "0.975rem",
    color: "#1f2937",
    wordWrap: "break-word",
    paddingLeft: "10px",
    maxHeight: 420,
    whiteSpace: 'pre-wrap',
    // overflowY: "auto"
  },
};

export const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: "rgba(0,0,0,0.3)",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "stretch",
    zIndex: 1100
  },
  backdrop: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.3)",
    backdropFilter: "blur(2px)",
    zIndex: -1,
  },
  panel: {
    backgroundColor: "#ffffff",
    borderRadius: "12px 0 0 12px",
    width: "500px",
    maxWidth: "550px",
    height: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    boxShadow: "-2px 0 12px rgba(0, 0, 0, 0.15)",
    animation: "slideInRight 0.3s ease-out forwards",
    color: "#111827",
    fontFamily: "'Inter', sans-serif",
    zIndex: 1,
  },
  header: {
    position: "relative",
    padding: "16px 24px",
    borderBottom: "1px solid #e5e7eb",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#f9fafb",
  },
  title: {
    margin: 0,
    position: "relative",
    fontSize: "20px",
    fontWeight: 600,
    color: "#1f2937",
    maxWidth: "320px",
    overflowX: "auto"
  },
  closeBtn: {
    background: "none",
    border: "none",
    fontSize: "20px",
    color: "#6b7280",
    cursor: "pointer",
    transition: "color 0.2s",
  },
  body: {
    padding: "20px 24px",
    flex: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    backgroundColor: "rgb(249 249 249)",
  },
  row: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "rgb(255, 255, 255)",
    borderRadius: "8px",
    padding: "12px 16px",
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 1px 1px -1px, rgba(0, 0, 0, 0.14) 0px 0.5px 0.5px 0.5px, rgba(0, 0, 0, 0.12) 0px 0.5px 0.5px 0.5px",
    border: "1px solid #ebebeb",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  },
  key: {
    width: "30%",
    fontWeight: 600,
    color: "#374151",
    fontSize: "1rem",
    wordWrap: "break-word",
    paddingRight: "10px"
  },
  value: {
    // width: "70%",
    width: "100%",
    fontSize: "0.875rem",
    color: "#1f2937",
    wordWrap: "break-word",
    paddingLeft: "10px",
    maxHeight: 130,
    overflowY: "auto",
    whiteSpace: 'pre-wrap',
  },
  subsheetValue: {
    // width: "70%",
    width: "100%",
    fontSize: "0.875rem",
    color: "#1f2937",
    wordWrap: "break-word",
    paddingLeft: "10px",
    maxHeight: 340,
    maxWidth: 315,
    whiteSpace: 'pre-wrap',
    // overflowY: "auto"
  },
  cellEditIcon: {
    backgroundColor: "rgb(244 244 244)",
    borderRadius: "50%",
    padding: 8,
    minWidth: 32,
    minHeight: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0,
    transition: "opacity 0.2s ease-in-out",
  }
};

export const keyframes = `
  @keyframes slideInRight {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0%);
    }
  }
`;

export const subsheetStyles = {
  container: { 
    backgroundColor: "#ffffff", 
    maxHeight: 320, 
    overflowY: "auto", 
    overflowX: "auto", 
    borderRadius: "6px", 
    maxWidth: 750, 
    border: "1px solid #e5e7eb",
    transition: "transform 0.2s ease, box-shadow 0.2s ease"
  },
  headerCell: { 
    color: "#1f2937", 
    fontWeight: 600, 
    whiteSpace: "nowrap", 
    backgroundColor: "#f3f4f6",
    minWidth: 100,
    borderBottom: "1px solid #e5e7eb"
  },
  tableCell: {
    whiteSpace: "nowrap",
    minWidth: 100,
    maxHeight: 130,
    overflowY: "auto", 
    color: "#374151",
    borderBottom: "1px solid #f3f4f6"
  },
  rowCell: {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontSize: "0.875rem",
    color: "#374151",
    minWidth: 100,
    maxHeight: 120,
    overflowY: "auto"
  }
};

export const expandedSubsheetStyles = {
  container: { 
    backgroundColor: "#ffffff", 
    maxHeight: 400,
    overflowY: "auto", 
    overflowX: "auto", 
    borderRadius: "6px", 
    maxWidth: 850, 
    border: "1px solid #e5e7eb",
    transition: "transform 0.2s ease, box-shadow 0.2s ease"
  },
  rowCell: {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontSize: "0.975rem",
    color: "#374151",
    minWidth: 130,
    maxHeight: 180,
    overflowY: "auto"
  },
  tableCell: {
    whiteSpace: "nowrap",
    minWidth: 130,
    maxHeight: 130,
    overflowY: "auto", 
    color: "#374151",
    borderBottom: "1px solid #f3f4f6"
  }
};